import React from 'react'
import t from 'prop-types'
import LabelList from '../../Labels/LabelList'
import Avatar from '../../Avatar'

const InsightsHeader = ({
  avatar,
  heading,
  labels,
  publishedDate,
  publishedDateTime,
}) => {
  return (
    <>
      {labels && <LabelList labels={labels} />}
      {heading && (
        <div className="mt-6 md:mt-8">
          <h1 className="font-serif font-semibold text-4xl lg:text-5xl leading-tight">
            {heading}
          </h1>
        </div>
      )}
      {avatar && (
        <div className="mt-6 md:mt-8">
          <Avatar
            isSmall
            {...avatar}
            publishedDate={publishedDate}
            publishedDateTime={publishedDateTime}
          />
        </div>
      )}
    </>
  )
}

InsightsHeader.propTypes = {
  avatar: t.object,
  heading: t.string,
  labels: t.object,
  publishedDate: t.string,
  publishedDateTime: t.string,
}

InsightsHeader.defaultProps = {}

export default InsightsHeader
